module.exports = __webpack_public_path__ + "static/media/room7.d4683dd3.jpg";